const transformCategoryString = (category = '', subcategory = '') => {
  return category ? `${category} > ${subcategory}` : '';
};

export default transformCategoryString;